
// *************** code with data dynamic ****************
import axios from "axios";
import authHeader from "./auth-header";
import API_BASE_URL2 from "../config/apiConfig";



const API_BASE = "http://localhost:8080/api";

// const API_BASE = "https://glistening-dedication-production.up.railway.app/api";

// 🔗 Endpoints dérivés
const API_BASE_URL = `${API_BASE}/courses/`; // Pour compatibilité avec le code existant
const API_BASE_URL_COURSES = `${API_BASE}/courses/`;
// const API_BASE_URL_SUBJECTS = `${API_BASE}/subjects/`;
const API_BASE_URL_SUBJECTS = `${API_BASE}/courses/subjects/`; // ✅ Correct

const API_BASE_URL_QUIZZES = `${API_BASE}/quizzes/`;
const API_BASE_TRAINING_EXERCISES = `${API_BASE}/training-exercises/`;

const API_BASE_Note_Finale= `${API_BASE}/note-finale/`;
const API_Progresse= `${API_BASE}/progress/`;


// const API_URL = "http://localhost:8080/api/auth/";

// const API_BASE_URL = `${API_BASE_URL2}/courses/`;


// Méthode pour uploader une image sur le serveur
const uploadImage = async (image) => {
    if (!image) {
        alert("Veuillez sélectionner une image.");
        throw new Error("Aucune image fournie.");
    }

    const formData = new FormData();
    formData.append("file", image);

    try {
        console.log("Envoi de l'image au backend : ", image);
        const response = await axios.post(API_BASE_URL + "upload-image", formData, {
            headers: {
                ...authHeader(),
                "Content-Type": "multipart/form-data",
            },
        });
        console.log("Réponse de l'upload de l'image :", response.data);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'upload de l'image :", error.response || error.message);
        const errorMessage = error.response?.data?.message || "Erreur lors de l'upload de l'image.";
        throw new Error(errorMessage);
    }
};

// Méthode pour créer un cours avec les données et l'image
const createCourse = async (courseData, file) => {
    // alert(" ...authHeader()" +  ...authHeader())
    if (!courseData || !file) {
        alert("Données ou fichier manquants pour créer le cours.");
        throw new Error("Les données du cours ou le fichier ne sont pas fournis.");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("course", JSON.stringify(courseData));

    try {
        console.log("Envoi des données du cours au backend :", courseData);
        const response = await axios.post(API_BASE_URL + "create-course", formData, { headers: authHeader() });
        console.log("Réponse de la création du cours :", response.data);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la création du cours :", error.response || error.message);
        const errorMessage = error.response?.data?.message || "Erreur lors de la création du cours.";
        throw new Error(errorMessage);
    }
};

const updateCourse = async (id, courseData, file) => {
    if (!id || !courseData) {
        throw new Error("L'ID du cours ou les données sont manquants.");
    }

    const formData = new FormData();
    if (file) {
        formData.append("file", file);
    }

    // Convertir imageUrl en image
    const cleanCourseData = { ...courseData };
    if (cleanCourseData.imageUrl) {
        cleanCourseData.image = cleanCourseData.imageUrl;
        delete cleanCourseData.imageUrl;
    }
    formData.append("course", JSON.stringify(cleanCourseData));

    try {
        const response = await axios.put(
            `${API_BASE_URL}update-course/${id}`,
            formData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour du cours :", error.response || error.message);
        throw new Error(error.response?.data || "Erreur lors de la mise à jour du cours.");
    }
};




const getCoursesByModerator = async (moderatorId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}?userId=${moderatorId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des cours :", error);
        throw error;
    }
};

// const update_infos_employe_by_id = (id, data) => {
//     return axios.put(`${API_URL}update/${id}`, data, { headers: authHeader() });
//   };

const addSubjectToCourse = async (courseId, subjectData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}${courseId}/subjects`,
            subjectData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du sujet :", error);
        const errorMessage = error.response?.data?.message || "Erreur lors de l'ajout du sujet.";
        throw new Error(errorMessage);
    }
};
// const getSubjectsByCourse = async (courseId) => {
//     try {
//         const response = await axios.get(`${API_BASE_URL}${courseId}/subjects`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la récupération des sujets :", error);
//         throw error;
//     }
// };


const getSubjectsByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/subjects`, {
            headers: authHeader() // Ajout du token d'authentification
        });

        return response.data.map(subject => ({
            id: subject.id,
            group_name: subject.group_name,
            title: subject.title,
            subTitle: subject.subTitle, // Vérifiez que ce champ est bien inclus
            content: subject.content,
            courseId: subject.courseId
        }));
    } catch (error) {
        console.error("Erreur lors de la récupération des sujets :", error);
        throw error; // Relancer l'erreur pour le debug
    }
};


const getCourseDetails = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${id}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
        throw error;
    }
};




const getUserPurchases = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}purchases`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des achats :", error);
        throw error;
    }
};

const getCategories = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}categories`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des catégories :", error);
        throw error;
    }
};


// Récupérer les sous-catégories d'une catégorie
const getSubcategories = async (categoryId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}categories/${categoryId}/subcategories`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des sous-catégories :", error);
        throw error;
    }
};
const addComment = async (subjectId, content) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/comments/${subjectId}`,
            // `http://localhost:8081/api/comments/${subjectId}`,

            { content },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du commentaire :", error);
        throw error;
    }
};

const updateSubject = (subjectId, updatedData) => {
    return axios.put(`${API_BASE_URL}subjects/${subjectId}`, updatedData, { headers: authHeader() });
};

const deleteSubject = async (subjectId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}subjects/${subjectId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la suppression du sujet :", error);
        throw error;
    }
};



const getQuestionsByQuiz = async (quizId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/${quizId}/questions`, {
            headers: authHeader(),
        });
        console.log("📦 Contenu brut reçu pour les questions :", response.data); // 🔥 Ajout
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des questions :", error);
        throw error;
    }
};



const submitQuizAnswers = async (quizId, answers) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/${quizId}/submit`,
            answers,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la soumission des réponses :", error);
        throw error;
    }
};


const addQuizWithQuestions = async (subjectId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/subjects/${subjectId}/quizzes_old`,
            quizData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du quiz avec questions :", error);
        throw error;
    }
};


const deleteQuiz = async (quizId) => {
    try {
        await axios.delete(`${API_BASE_URL}quizzes/${quizId}`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error("Erreur lors de la suppression du quiz :", error);
        throw error;
    }
};



const getQuizzesBySubject = async (subjectId) => {
    const response = await axios.get(`${API_BASE_URL}quizzes/subject/${subjectId}`, { headers: authHeader() });
    return response.data;
};


const addQuizToSubject = async (subjectId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/subjects/${subjectId}/quizzes`,
            {
                ...quizData,
                course: { id: subjectId }, // Vérifie que course.id est bien renseigné
                linkType: 'subject',  // 🔥
                linkId: subjectId     // 🔥
            },
            { headers: authHeader() }
        );

        console.log("Quiz ajouté avec succès :", response.data); // Debug

        return response.data; // Retourner la réponse pour mise à jour de l'UI
    } catch (error) {
        console.error("Erreur lors de l'ajout du quiz :", error.response?.data || error.message);
        throw error; // Relancer l'erreur pour affichage correct
    }
};



// const addQuestionToQuiz = async (quizId, questionData) => {
//     const response = await axios.post(`${API_BASE_URL}quizzes/${quizId}/questions`, questionData, { headers: authHeader() });

//     if (!response.data || !response.data.id) {
//         throw new Error("Erreur : ID de la question non retourné !");
//     }

//     return response.data;
// };


const addQuestionToQuiz = async (quizId, questionData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/${quizId}/questions`,
            questionData, // Inclure { text, explanation }
            { headers: authHeader() }
        );

        if (!response.data || !response.data.id) {
            throw new Error("Erreur : ID de la question non retourné !");
        }

        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout de la question :", error);
        throw error;
    }
};


const addAnswerToQuestion = async (questionId, answerData) => {
    if (!questionId) {
        throw new Error("Erreur : ID de la question manquant !");
    }

    const response = await axios.post(`${API_BASE_URL}quizzes/questions/${questionId}/answers`, answerData, { headers: authHeader() });

    return response.data;
};

const getAnswersByQuestion = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}/answers`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des réponses :", error);
        throw error;
    }
};

const updateQuestionExplanation = async (questionId, explanation) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/${questionId}/update-explanation`,
            { explanation }, // Envoyer l'explication dans un objet
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de l'explication :", error);
        throw error;
    }
};
const getQuestionById = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération de la question :", error);
        throw error;
    }
};

// const updateQuestion = async (questionId, questionData) => {
//     try {
//         const response = await axios.put(`${API_BASE_URL}quizzes/questions/${questionId}`, questionData, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la mise à jour de la question :", error);
//         throw error;
//     }
// };

const updateQuestion = async (questionId, questionData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}quizzes/questions/${questionId}`, questionData, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la question :", error);
        throw error;
    }
};


const updateAnswer = async (answerId, answerData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}quizzes/answers/${answerId}`, answerData, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la réponse :", error);
        throw error;
    }
};

const deleteQuestion = async (questionId) => {
    try {
        await axios.delete(`${API_BASE_URL}quizzes/questions/${questionId}`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error("Erreur lors de la suppression de la question :", error);
        throw error;
    }
};

const deleteAnswer = async (answerId) => {
    try {
        await axios.delete(`${API_BASE_URL}quizzes/answers/${answerId}`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error("Erreur lors de la suppression de la réponse :", error);
        throw error;
    }
};

const deleteCourse = async (courseId) => {
    try {
        await axios.delete(`${API_BASE_URL}${courseId}`, { headers: authHeader() });
    } catch (error) {
        console.error("Erreur lors de la suppression du cours :", error);
        throw error;
    }
};

// const updateQuiz = async (quizId, quizData) => {
//     try {
//         const response = await axios.put(
//             `${API_BASE_URL}quizzes/${quizId}`,
//             {
//                 title: quizData.title,
//                 isChecked: quizData.isChecked,
//                 progressPercentage: quizData.progressPercentage,
//                 attemptOnce: quizData.attemptOnce // ✅ Ajouter cette ligne
//             },
//             { headers: authHeader() }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la mise à jour du quiz :", error);
//         throw error;
//     }
// };


const updateQuiz = async (quizId, quizData) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}quizzes/${quizId}`,
      {
        title: quizData.title,
        attemptOnce: quizData.attemptOnce,
        elementType: quizData.elementType,                 // optionnel
        referenceElementId: quizData.referenceElementId,   // pour positionnement
        positioning: quizData.positioning,                  // BEFORE ou AFTER
        progressPercentage: quizData.progressPercentage    // ✅ AJOUT ICI

      },
      { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du quiz :", error);
    throw error;
  }
};



const updateQuizProgress = async (quizId, isChecked, progressPercentage) => {
    try {
        const response = await axios.put(`${API_BASE_URL}quizzes/${quizId}/updateProgress`, {
            isChecked,
            progressPercentage,
        }, { headers: authHeader() });

        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour du quiz :", error);
        throw error;
    }
};

const updateCorrectAnswers = async (questionId, data) => {
    try {
        console.log("📡 Envoi au backend :", questionId, data); // 🔥 Vérification

        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/update-correct-answers/${questionId}`, // 🔥 Correction de l'URL
            data,
            { headers: authHeader() }
        );

        console.log("✅ Réponse du backend :", response.data); // 🔥 Vérification
        return response.data;
    } catch (error) {
        console.error("❌ Erreur API :", error.response?.data || error.message);
        throw error;
    }
};

const updateAnswersOrder = async (questionId, orderedAnswerIds) => {
    try {
        console.log("📡 Envoi au backend pour mise à jour de l'ordre :", orderedAnswerIds);

        const response = await axios.put(
            `${API_BASE_URL}quizzes/questions/${questionId}/update-order`,
            orderedAnswerIds,
            { headers: authHeader() }
        );

        console.log("✅ Réponse du backend :", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la mise à jour de l'ordre des réponses :", error.response?.data || error.message);
        throw error;
    }
};

// Définition de l'objet de service

const uploadAttachmentToCourse = async (courseId, file) => {
    if (!file) {
        throw new Error("Aucun fichier sélectionné pour l'upload.");
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
        const response = await axios.post(
            `${API_BASE_URL}${courseId}/attachments`,
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'upload de la pièce jointe :", error.response || error.message);
        throw new Error(error.response?.data?.message || "Erreur lors de l'upload.");
    }
};

const getAttachmentsByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/attachments`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des pièces jointes :", error);
        throw error;
    }
};
// Ajout d'une ressource pour un cours
const addResourceToCourse = async (courseId, resourceData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}${courseId}/resources`,
            resourceData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout de la ressource :", error);
        throw error;
    }
};

// Récupérer toutes les ressources d'un cours
const getResourcesByCourse = async (courseId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}${courseId}/resources`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des ressources :", error);
        throw error;
    }
};


const getResourcesBySubject = async (subjectId) => {
    try {
        const response = await axios.get(`${API_BASE_URL_COURSES}${subjectId}/resources`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des ressources par sujet :", error);
        throw error;
    }
};








const getQuizzesByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/quizzes`, { headers: authHeader() });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des quizzes du cours :", error);
        throw error;
    }
};

const getEvaluationByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/evaluation`, { headers: authHeader() });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des quizzes du cours :", error);
        throw error;
    }
};



const addQuizToCourse = async (courseId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/courses/${courseId}/quizzes`,
            {
                ...quizData,
                linkType: 'course',   // 🔥
                linkId: courseId      // 🔥
            },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du quiz au cours :", error.response?.data || error.message);
        throw error;
    }
};


const addEvaluationToCourse = async (courseId, quizData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}quizzes/courses/${courseId}/evaluation`,
            {
                ...quizData,
                linkType: 'evaluation',   // 🔥
                linkId: courseId      // 🔥
            },
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout du l'évaluation au cours :", error.response?.data || error.message);
        throw error;
    }
};



const uploadAttachmentToSubject = async (subjectId, file) => {
    if (!file) {
        throw new Error("Aucun fichier sélectionné pour l'upload.");
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
        const response = await axios.post(
            `${API_BASE_URL}subjects/${subjectId}/attachments`,
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'upload de la pièce jointe au sujet :", error.response || error.message);
        throw new Error(error.response?.data?.message || "Erreur lors de l'upload.");
    }
};
const addResourceToSubject = async (subjectId, resourceData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}subjects/${subjectId}/resources`,
            resourceData,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout de la ressource au sujet :", error);
        throw error;
    }
};
const getAttachmentsBySubject = async (subjectId) => {
    const response = await axios.get(`${API_BASE_URL}subjects/${subjectId}/attachments`, {
        headers: authHeader(),
    });
    return response.data;
};


// getAttachmentsBySubject(subjectId) {
//     return axios
//         .get(`${API_BASE}/subjects/${subjectId}/attachments`, { headers: authHeader() })
//         .then((response) => response.data);
// };


// const getResourcesBySubject = async (subjectId) => {
//     try {
//         const response = await axios.get(`${API_BASE_URL}subjects/${subjectId}/resources`, {
//             headers: authHeader(),
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de la récupération des ressources par sujet :", error);
//         throw error;
//     }
// };


const uploadTrainingExercise = async (courseId, file, title, instructionsText) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", title);
    formData.append("instructionsText", instructionsText);

    try {
        const response = await axios.post(
            // `${API_BASE_URL}${courseId}/training-exercises`, // ✅ Correction ici
            `${API_BASE_TRAINING_EXERCISES}course/${courseId}`, // ✅ URL correcte maintenant

            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la création de l'exercice :", error.response || error.message);
        throw new Error(error.response?.data?.message || "Erreur lors de la création.");
    }
};


const getTrainingExercisesByCourse = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_TRAINING_EXERCISES}course/${courseId}`, {
            headers: authHeader()
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error.response || error.message);
        throw error;
    }
};


const getTrainingExercisesByCourseByTriningId = async (traiiningId) => {
    try {
        // http://localhost:8080/api/training-exercises/training/58/responses
        const response = await axios.get(`${API_BASE_TRAINING_EXERCISES}training/${traiiningId}/responses`, {
            headers: authHeader()
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error.response || error.message);
        throw error;
    }
};

const getTrainingExercisesByCourseByTriningIdAndUserId = async (trainingId, userId = null) => {
    try {
        let url = `${API_BASE_TRAINING_EXERCISES}training/${trainingId}/responses_for_user`;

        // Ajoute le paramètre userId s'il est fourni
        if (userId) {
            url += `?userId=${userId}`;
        }

        const response = await axios.get(url, {
            headers: authHeader()
        });

        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error.response || error.message);
        throw error;
    }
};


const getTrainingExercisesByCourseByUser = async (courseId) => {
    try {
        // http://localhost:8080/api/training-exercises/course/5/responses-with-users
        const response = await axios.get(`${API_BASE_TRAINING_EXERCISES}course/${courseId}/responses-with-users`, {
            headers: authHeader()
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error.response || error.message);
        throw error;
    }
};

const updateTrainingGrade = async (responseId, grade) => {
    try {
        const response = await axios.put(
            `${API_BASE_TRAINING_EXERCISES}responses/${responseId}/grade`,
            null,
            {
                params: { grade },
                headers: authHeader(),
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de la note :", error);
        throw error;
    }
};




const deleteTrainingExercise = async (exerciseId) => {
    return axios.delete(`${API_BASE_TRAINING_EXERCISES}${exerciseId}`, {
        headers: authHeader()
    });
};

const updateExercise = async (id, title, instructionsText) => {
    try {
        const response = await axios.put(`${API_BASE_TRAINING_EXERCISES}${id}`, null, {
            params: { title, instructionsText },
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la mise à jour de l'exercice :", error);
        throw error;
    }
};


const getTrainingsByCourse = async (courseId) => {
    return axios.get(`${API_BASE_TRAINING_EXERCISES}course/${courseId}`, { headers: authHeader() });
}

// const uploadStudentTrainingResponse = async (exerciseId, file) => {
//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//         const response = await axios.post(
//             `${API_BASE_TRAINING_EXERCISES}${exerciseId}/upload-response`,
//             formData,
//             {
//                 headers: {
//                     ...authHeader(),
//                     "Content-Type": "multipart/form-data",
//                 },
//             }
//         );
//         return response.data;
//     } catch (error) {
//         console.error("Erreur lors de l'upload du fichier étudiant :", error.response || error.message);
//         throw error;
//     }
// };

const uploadStudentTrainingResponse = async (exerciseId, userId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("userId", userId); // ✅ ajout userId

    try {
        const response = await axios.post(
            `${API_BASE_TRAINING_EXERCISES}${exerciseId}/upload-response-user`,
            formData,
            {
                headers: {
                    ...authHeader(),
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'upload du fichier étudiant :", error.response || error.message);
        throw error;
    }
};



const getQuizById = async (quizId) => {

    return axios.get(`${API_BASE_URL_QUIZZES}${quizId}`, {
        headers: authHeader(),
    });
};


const getMatchingPairsByQuestion = async (questionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}quizzes/questions/${questionId}/matching-pairs`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des paires MATCHING :", error);
        throw error;
    }
};
const addMatchingPairToQuestion = async (questionId, pair) => {
    // return axios.post(`${API_BASE}/quizzes/questions/${questionId}/matching-pairs`, pair, { headers: authHeader() });
    return axios.post(`${API_BASE_URL}quizzes/questions/${questionId}/matching-pairs`, pair, {
        headers: authHeader()
    });

}

export const getSubjectById = async (subjectId) => {
    try {
        const response = await axios.get(`${API_BASE_URL_SUBJECTS}${subjectId}`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("❌ Erreur lors de la récupération du sujet par ID :", error);
        throw error;
    }
};

const generateBadge = async (student, course, score, threshold) => {
    const response = await axios.get(
        `${API_BASE}/badges/generate`,
        {
            params: { student, course, score, threshold },
            headers: {
                ...authHeader(),
                "Accept": "application/pdf"
            },
            responseType: 'blob'
        }
    );

    return new Blob([response.data], { type: "application/pdf" });
};

// const getCourseDetails = async (id) => {
//   const response = await axios.get(`${API_BASE_URL}${id}`, {
//     headers: authHeader(),
//   });
//   return response.data;
// };
const getThreshold = async (courseId) => {
    // http://localhost:8080/api/badges/threshold/1
    const response = await axios.get(`${API_BASE}/badges/threshold/${courseId}`, {
        headers: authHeader()
    });
    return response.data; // ça retourne un entier (le seuil)
};

const updateThreshold = async (courseId, threshold) => {
    return axios.put(
        `${API_BASE}/badges/threshold/${courseId}/${threshold}`,
        null, // aucun corps requis
        {
            headers: authHeader()
        }
    );
};

// const getBadgeUrl = async (student, courseId) => {
//   try {
//     const response = await axios.get(`${API_BASE}/badges/badges/url`, {
//       params: { student, courseId },
//       headers: authHeader()
//     });
//     return response.data; // string: 'file/d/...'
//   } catch (error) {
//     return null; // Pas de badge encore
//   }
// };


const getBadgeUrl = async (student, courseId, courseTitle, score, threshold) => {
  try {
    const response = await axios.get(`${API_BASE}/badges/generate`, {
      params: {
        student,
        courseId,
        course: courseTitle,
        score,
        threshold
      },
      headers: authHeader()
    });

    if (response.status === 200 && response.data?.startsWith("http")) {
      return response.data;
    }

    return null;
  } catch (error) {
    if (error.response?.status === 404) {
      console.log("ℹ️ Aucun badge encore généré.");
    } else {
      console.error("❌ Erreur API getBadgeUrl:", error);
    }
    return null;
  }
};




// const getAllUsernames = async () => {
//   const response = await axios.get("http://localhost:8080/api/auth/users", {
//     headers: authHeader()
//   });
//   return response.data; // ex: ["moderateur3", "taoufik", "etudiant2"]
// };

const getAllUsernames = async () => {
  const response = await axios.get(`${API_BASE}/auth/users`, {
    headers: authHeader()
  });
  return response.data; // ex: ["moderateur3", "taoufik", "etudiant2"]
};


const getBadgesByCourse = async (courseId) => {
    const response = await axios.get(`${API_BASE}/badges/course/${courseId}`, {
        headers: authHeader(),
    });
    return response.data;
};

const deleteBadge = async (badgeId) => {
    return axios.delete(`${API_BASE}/badges/${badgeId}`, {
        headers: authHeader(),
    });
};

const getCourseStructure = async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/structure`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération de la structure du cours :", error);
        throw error;
    }
};

const getquizzes_of_cours= async (courseId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${courseId}/quizzes_of_cours`, {
            headers: authHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération de la structure du cours :", error);
        throw error;
    }
};


const uploadTrainingExerciseWithPositioning = async (courseId, meta, file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("exercise", JSON.stringify(meta)); // ⚠️ Nom du champ backend : "exercise"

    try {
        const response = await axios.post(
            `${API_BASE_TRAINING_EXERCISES}course/${courseId}/positioned`,
            formData,
            {
                headers: {
                    ...authHeader(),
                    "Content-Type": "multipart/form-data"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'ajout positionné de l'exercice :", error.response || error.message);
        throw error;
    }
};

const getCourseElements = async (courseId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}${courseId}/elements`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des éléments du cours :", error);
    throw error;
  }
};

const Getgroupnames = async (courseId) => {
  try {
    const response = await axios.get(`${API_BASE_URL_SUBJECTS}${courseId}/group-names`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des éléments du cours :", error);
    throw error;
  }
};

const deleteTrainingBloc = async (trainingId) => {
    try {
        const response = await axios.delete(
            `${API_BASE_TRAINING_EXERCISES}delete/${trainingId}`,
            { headers: authHeader() }
        );
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la suppression du bloc d'entraînement :", error);
        throw error;
    }
};


export const updateTrainingExerciseWithPositioning = async (id, payload, file) => {
  const formData = new FormData();

  payload.referenceElementId = Number(payload.referenceElementId);

formData.append("exercise", JSON.stringify(payload));
  if (file) {
    formData.append("file", file);
  }

  return axios.put(
    `${API_BASE_TRAINING_EXERCISES}training/${id}/positioned`,
    formData,
    {
      headers: {
        ...authHeader(), // ✅ Authentification ajoutée ici
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// const submitQuizResult = async ({ userId, quizId, scoreObtained, scoreTotal }) => {
//   try {
//     const response = await axios.post(
//       `${API_BASE}/courses/user-quiz-results`,
//       { userId, quizId, scoreObtained, scoreTotal },
//       { headers: authHeader() }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Erreur lors de la soumission du résultat du quiz :", error);
//     throw error;
//   }
// };

const submitQuizResult = async ({ userId, quizId, scoreObtained, scoreTotal, answers }) => {
  try {
    const response = await axios.post(
      `${API_BASE}/courses/user-quiz-results`,
      { userId, quizId, scoreObtained, scoreTotal, answers }, // 👈 Ajout ici
      { headers: authHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la soumission du résultat du quiz :", error);
    throw error;
  }
};


const getQuizReviewResults = async (userId, quizId) => {
  try {
    const response = await axios.get(
      `${API_BASE}/courses/user-quiz-results/review`,
      {
        params: { userId, quizId },
        headers: authHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération de la revue des résultats :", error);
    throw error;
  }
};


const CalculeNoteFinale = async (courseId, userId) => {
  try {
    // console.log("📌 [SERVICE] Appel API Note Finale avec paramètres :", {
    //   courseId,
    //   userId
    // });

    const url = `${API_BASE_Note_Finale}${courseId}/${userId}`;
    console.log("🌐 [SERVICE] URL API appelée :", url);

    const response = await axios.get(url, {
      headers: authHeader(),
    });

    console.log("✅ [SERVICE] Réponse API reçue :", response.data);

    return response.data;
  } catch (error) {
    console.error("❌ [SERVICE] Erreur lors de la récupération de la note finale :", error);
    throw error;
  }
};

const GetNotAttemptedItems = async (courseId, userId) => {
  try {
    const url = `${API_BASE_Note_Finale}not-attempted/${courseId}/${userId}`;
    console.log("🌐 [SERVICE] URL API appelée :", url);

    const response = await axios.get(url, {
      headers: authHeader(),
    });

    console.log("✅ [SERVICE] Réponse API reçue :", response.data);

    return response.data;
  } catch (error) {
    console.error("❌ [SERVICE] Erreur lors de la récupération des éléments non tentés :", error);
    throw error;
  }
};



const CalculePrgresseByType = async (type, courseId, userId, quizId = null) => {
  try {

    //  console.log("📌 [SERVICE] Appel API progresse  avec paramètres :", {
    //   type,
    //   courseId,
    //   userId,
    //   quizId

    // });
    // Construire l'URL avec query params
    let url = `${API_Progresse}?type=${type}&courseId=${courseId}&userId=${userId}`;
    if (quizId !== null) {
      url += `&quizId=${quizId}`;
    }

    // console.log("🌐 [SERVICE] URL API appelée :", url);

    // Appel à l'API
    const response = await axios.get(url, {
      headers: authHeader(),
    });

    // console.log("✅ [SERVICE] Réponse API reçue :", response.data);

    return response.data; // Tableau JSON reçu
  } catch (error) {
    console.error("❌ [SERVICE] Erreur lors de la récupération du progrès :", error);
    throw error;
  }
};

export const getAttemptOnceByCourse = async (courseId) => {
  try {
    const response = await axios.get(
      `${API_BASE}/courses/quizzes/courses/${courseId}/attempt-once`,
      {
        headers: authHeader(),
      }
    );
    return response.data; // true ou false
  } catch (error) {
    console.error("❌ Erreur lors de la récupération de attemptOnce :", error);
    throw error;
  }
};
const courseService = {
    uploadImage,
    createCourse,
    getCoursesByModerator,
    addSubjectToCourse, getSubjectsByCourse, getCourseDetails, getUserPurchases,
    getCategories, getSubcategories, addComment, updateCourse
    , updateSubject, deleteSubject, getQuizzesBySubject, submitQuizAnswers
    , getQuestionsByQuiz,
    getQuizzesBySubject,
    addQuizToSubject,
    deleteQuiz, addQuizWithQuestions, addQuestionToQuiz, addAnswerToQuestion,
    getAnswersByQuestion, updateQuestionExplanation, getQuestionById
    , updateQuestion, updateAnswer, deleteQuestion, deleteAnswer

    , deleteCourse
    , updateQuiz
    , updateQuizProgress
    , updateCorrectAnswers
    , updateAnswersOrder
    , uploadAttachmentToCourse
    , getAttachmentsByCourse

    , addResourceToCourse
    , getResourcesByCourse
    , getQuizzesByCourse
    , addQuizToCourse

    , uploadAttachmentToSubject
    , addResourceToSubject
    , getAttachmentsBySubject
    , getResourcesBySubject
    , getResourcesBySubject

    , uploadTrainingExercise
    , getTrainingExercisesByCourse
    , updateTrainingGrade
    , deleteTrainingExercise
    , updateExercise
    , getTrainingsByCourse
    , uploadStudentTrainingResponse
    , getQuizById
    , getMatchingPairsByQuestion
    , addMatchingPairToQuestion
    , getSubjectById

    , generateBadge
    , getThreshold
    , updateThreshold
    , getBadgeUrl
    ,getAllUsernames
    ,getBadgesByCourse
    ,deleteBadge
    ,getCourseStructure
    ,getquizzes_of_cours
    ,uploadTrainingExerciseWithPositioning
,getCourseElements
,Getgroupnames
,deleteTrainingBloc
, updateTrainingExerciseWithPositioning
,addEvaluationToCourse
,getEvaluationByCourse
,submitQuizResult
,getQuizReviewResults
,getTrainingExercisesByCourseByUser
,getTrainingExercisesByCourseByTriningId
,getTrainingExercisesByCourseByTriningIdAndUserId
,CalculeNoteFinale
,CalculePrgresseByType
,getAttemptOnceByCourse
,GetNotAttemptedItems
};

// Exportation de l'objet
export default courseService;
